var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightPinkFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 98,
    viewBox: "0 0 115 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6133e-07 41.1035C1.82432e-06 69.9974 57.5003 41.1035 57.5003 41.1035C57.5003 41.1035 -7.01663e-07 12.2095 5.6133e-07 41.1035Z",
    fill: "#F2E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.996 41.1035C114.996 69.9974 57.4958 41.1035 57.4958 41.1035C57.4958 41.1035 114.996 12.2095 114.996 41.1035Z",
    fill: "#F2E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7541 90.8999C53.7769 105.347 57.5042 41.1031 57.5042 41.1031C57.5042 41.1031 3.73122 76.4529 28.7541 90.8999Z",
    fill: "#F2E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.258 -8.69339C111.281 5.75356 57.5078 41.1033 57.5078 41.1033C57.5078 41.1033 61.2351 -23.1403 86.258 -8.69339Z",
    fill: "#F2E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.242 90.9004C61.2192 105.347 57.4919 41.1036 57.4919 41.1036C57.4919 41.1036 111.265 76.4534 86.242 90.9004Z",
    fill: "#F2E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7498 -8.69339C3.72697 5.75356 57.5 41.1033 57.5 41.1033C57.5 41.1033 53.7727 -23.1403 28.7498 -8.69339Z",
    fill: "#F2E7F5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPinkFlower);
export default __webpack_public_path__ + "static/media/light-pink-flower.2525af585589876ab59a0eda1e6e0cfd.svg";
export { ForwardRef as ReactComponent };